import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import Balls from '../components/Commons/Balls';
import NewAndEdit from '../components/MakeOrder';
import ShareView from '../components/MakeOrder/OrderView/index';
import NewPassword from '../components/Forgot/NewPassword';
import InvoiceSuccess from '../components/Invoice/InvoiceSuccess';
import InvoiceError from '../components/Invoice/InvoiceError';
import Invite from '../components/Invite';
import {getUpdateUserData, getCurrentUser} from '../actions/session';
import { askForPermissioToReceiveNotifications } from '../push-notification';
import { getHeader, getToken } from '../helper';
import xIcon from '../images/x-button.png';

import PrivateRoute from '../components/Commons/PrivateRoute';
import PrivateRouteForToken from '../components/Commons/PrivateRouteForToken';
import BottomPanelSecond from '../components/BottomPanelSecond';
import InvatePrivateRoute from '../components/Commons/InvatePrivateRoute';
import {
    Home, 
    Orders,
    Execute,
    Profile,
    SignUp,
    Forgot,
    Account,
    BuyReady,
    HeaderTop,
    BottomPanel,
    Information,
    SignIn,
    News,
    AcceptRequest,
    NoMatch,
} from "../components";

import $ from "jquery";
window.jQuery = $;
require("@fancyapps/fancybox");


class App extends Component {
    constructor(props) {
      super(props)

      this.state = {
        adaptiveMenuToggle: false,
        contentMargin: 0,
        isChecked: false,

        initFetching: false,
      }
    }

    componentWillMount() {
        const token = localStorage.getItem("id_token");
        const {
            session,
            dispatch,
            location,
            history
        } = this.props;

        const params = new URLSearchParams(window.location.search.substring(1));
        const paramToken = params.get('token');

        if(token || paramToken){
            if(paramToken) {
                localStorage.setItem('id_token', paramToken);
            }
            
            this.setState({initFetching: true});
            
            setTimeout(() => {
                dispatch(
                    getCurrentUser(
                        (paramToken || token),
                        () => {
                            if(paramToken) {                      
                                history.replace(location.pathname, '');
                            }
                        }
                    )
                );
            }, 10);
        }

        window.addEventListener('storage', (event) => {
            if(event.key === "change_balance") {
                dispatch(getUpdateUserData(session.token))
                setTimeout(() => {
                    localStorage.removeItem('change_balance')
                }, 500)
            }
        });

        window.onscroll = () => {
            let header = document.querySelector(".header-top");
            let airBlock = document.querySelector(".air-block");
            let orderList = document.querySelector(".order-list");
            let homeList = document.querySelector(".home-list");
            var height = header && header.offsetHeight || null;
            const scrolled = window.pageYOffset || document.documentElement.scrollTop
            
            if(scrolled === 45 && header && airBlock) {
                const margin = header.offsetHeight + airBlock.offsetHeight - 125; 
                this.setState({ contentMargin: margin })
            }

            if(scrolled >= 45){
                if(orderList) {
                    orderList.style.marginTop = this.state.contentMargin + "px"
                }
                if(homeList) {
                    homeList.style.marginTop = this.state.contentMargin + "px"
                }
                if(header) header.classList.add("header-colored");
                if(airBlock){
                    airBlock.classList.add("block-fixed");

                    if(height) airBlock.style.top = height + "px";
                }
            }
            else {
                if(header) header.classList.remove("header-colored");
                if(airBlock) airBlock.classList.remove("block-fixed");
                if(orderList) orderList.style.marginTop = 0;
                if(homeList) homeList.style.marginTop = 0;
            }
        }
    }

    componentDidUpdate(prevProps) {
        const {
            session,
        } = this.props;

        if(
            prevProps.session.isFetching !== session.isFetching &&
            !session.isFetching && session.isLoggedIn
        ) {
            askForPermissioToReceiveNotifications(this.afterGetToken);
        }

        if(
            prevProps.session.isFetching !== session.isFetching &&
            !session.isFetching
        ) {
            this.setState({initFetching: false});
        }
    } 

    async afterGetToken(token) {
        let formData = new FormData();
        formData.append("registration_id", token);
        formData.append("device_id", "web");
        formData.append("name", "PC");
        formData.append("type", "");
        formData.append("active", true);

        axios.post(
            `${window.siteUrl}/devices/`,
            formData,
            {
                headers: {
                    ...getHeader(),
                    locHeaders: { 'Content-Type': 'multipart/form-data' }
                }
            }
        )
        .then(function (response) {
            // console.log("token sended successfuly", response)
        })
        .catch(function (error) {
            // console.log("token sended error", error)
        });
    }

    handleAdaptiveMenu() {
        this.setState({
            adaptiveMenuToggle: !this.state.adaptiveMenuToggle
        }, () => {
            let menu = document.querySelector('.header-right');
            let menubtn = document.querySelector('.user-menu-icon');
            if(this.state.adaptiveMenuToggle) {
                menu.classList.add('open');
                menubtn.classList.add('open');
            } else {
                menu.classList.remove('open');
                menubtn.classList.remove('open');
            }
        });
    }

    render() {
        const { session } = this.props;
        const { isLoggedIn, isFetching } = session;

        if(isFetching || this.state.initFetching) return <div className="loading-indicator"></div>

        if(session.errorStatus === 500 || session.errorStatus === 502) {
            return  <div style={{background:'#ffbebe', padding:'15px',alignItems:'center',display:'flex'}}>
                        <img src={xIcon} style={{width:'24px',height:'24px',marginRight:'10px'}}/>
                        {session.errorMessage.detail}
                    </div>
        }


        return(
            <BrowserRouter>
                {
                    <div>
                        <HeaderTop
                            adaptiveMenuToggle={this.state.adaptiveMenuToggle}
                            handleMenu={() => this.handleAdaptiveMenu()}
                            session={session}
                        />
                            
                        <BottomPanelSecond/>
                        <Balls />
                        
                        <Switch>
                            <Route exact path="/" component={Home} />
                            {
                                isLoggedIn ?
                                <Route path="/profile/:id?" component={Profile} />
                                :
                                <Route path="/profile/:id" component={Profile} />
                            }
                            <Route path="/orders/execute/:id" component={Execute} />
                            <PrivateRoute path="/orders/:option?/:id?" session={session} component={Orders}/>
                            <Route path="/makeorder/:id?" session={session} component={NewAndEdit}/>
                            <PrivateRoute path="/account/balance" session={session} component={Account}/>
                            <PrivateRoute path="/account/entity/balance" session={session} component={Account}/>
                            <PrivateRoute path="/account" session={session} component={Account}/>

                            <Route exact path="/buy/:id?" title="Покупка Fuad" component={BuyReady}/>
                            <Route path="/buy/single/:id?" component={ShareView}/>
                            <Route path="/restore-password/:id?" component={NewPassword}/>
                            
                            {
                                (!isLoggedIn) ? <Route path="/signin/:code?/:oauth_token?" component={SignIn} />
                                : <Redirect from="/signin" to="/" />
                            }
                            {
                                (!isLoggedIn) ? <Route path="/signup" component={SignUp} />
                                : <Redirect from="/signup" to="/" />
                            }
                            {
                                (!isLoggedIn) ? <Route path="/forgot" component={Forgot} />
                                : <Redirect from="/forgot" to="/" />
                            }
                            <Route path="/information/:id?" component={Information} />
                            <Route path="/news" component={News} />
                            
                            <InvatePrivateRoute path="/invite/:code?" session={session} component={Invite}/>

                            <InvatePrivateRoute exact path="/invoice/error/" session={session} component={InvoiceError}/>
                            <InvatePrivateRoute exact path="/invoice/success/" session={session} component={InvoiceSuccess}/>

                            <Route path="/acceptrequest" component={AcceptRequest} />
                            
                            <Route component={NoMatch}/>
                            <Route path="/404" component={NoMatch}/>
                        </Switch>

                        <button className="arrow-down"></button>

                    </div>
                }
            </BrowserRouter>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/app.js